import {UseCase} from '@s-ui/domain'
/**
 * @implements UseCase
 */
export class SaveLastDetailViewedAdsUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.localStorageRepository
   * @param {Object} deps.config
   */
  constructor({localStorageRepository, config}) {
    super({localStorageRepository, config})

    this._localStorageRepository = localStorageRepository
    this._config = config
  }

  /**
   * @return {Promise<Object, Error>} last viewed detail id
   */
  async execute({adId}) {
    return this._localStorageRepository.saveLastDetailViewed({adId})
  }
}
